import * as React from 'react';
export var useHostParts = function () {
    return React.useMemo(function () {
        var _a = window.location, host = _a.host, hostname = _a.hostname, protocol = _a.protocol;
        var index = host.indexOf('.');
        var lastIndex = host.lastIndexOf('.');
        return index === lastIndex
            ? {
                host: host,
                hostname: hostname,
                protocol: protocol,
                subdomain: null,
            }
            : {
                host: host.slice(index + 1),
                hostname: hostname.slice(index + 1),
                protocol: protocol,
                subdomain: host.slice(0, index),
            };
    }, []);
};
